import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Response } from '../models/response';
import { environment } from 'src/environments/environment';

const baseURL = `${environment.api}/hobby`;
const requestURL = `${environment.api}/genericrequests`;
@Injectable({
  providedIn: 'root'
})
export class HobbyService {
  constructor(private http: HttpClient) {}

  getHobbies() {
    return of({ result: [], count_hobby: 0 });
  }

  personalHobbies() {
    return of({ result: [] });
  }

  parentHobbies() {
    return of({ result: [], count_hobby: 0 });
  }

  childHobbies(hobby_id: any) {
    return of({ result: [] });
  }

  addHobby(hobby_id: string): Observable<Response<any>> {
    return of({ result: null } as Response<any>);
  }

  add_hobby_category(
    hobby_id: any,
    hobby_category_id: any
  ): Observable<Response<any>> {
    return of({ result: null } as Response<any>);
  }

  updateHobby(hobby_id: number, formData: any): Observable<any> {
    return of({ result: formData });
  }

  deleteHobby(hobby_id: any): Observable<Response<any>> {
    return of({ result: null } as Response<any>);
  }

  deleteHobbyUser(hobby_id: any): Observable<Response<any>> {
    return of({ result: null } as Response<any>);
  }

  /* GESTIONE RICHIESTA NUOVO HOBBY */
  reqNewHobby(request: any): Observable<any> {
    return of({ result: request });
  }

  getHobbyRequests() {
    return of({ result: [] });
  }

  updateStatus(id: number): Observable<any> {
    return of({ result: { status: 'Declined' } });
  }

  storeOnRequest(hobby: any): Observable<any> {
    return of({ result: hobby });
  }
}
